import { render, staticRenderFns } from "./Colourpicker.vue?vue&type=template&id=01b149ad&scoped=true"
import script from "./Colourpicker.vue?vue&type=script&lang=js"
export * from "./Colourpicker.vue?vue&type=script&lang=js"
import style0 from "./Colourpicker.vue?vue&type=style&index=0&id=01b149ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b149ad",
  null
  
)

export default component.exports